import React, { useCallback } from 'react'
import { format } from '@dt/fe-utils'
import { Stepper, ProductImage } from '@cps'
import { cartMobx } from 'restaurant'
import CashierController from 'controllers/cashierController'
import { observer } from 'mobx-react'
import './index.scss'

interface IProps {
  product: IViewProduct;
  onClick: (product: IViewProduct) => void;
}

const ActProductItem: React.FC<IProps> = props => {
  const { product, onClick } = props
  const { productNoToCntMap } = cartMobx.cartResult
  const count = productNoToCntMap?.[product.no] || 0
  const handleChangeCnt = useCallback((isAdd: boolean, event: React.MouseEvent) => {
    event.stopPropagation()
    CashierController.handleProductToCart({
      type: isAdd ? 'add' : 'minus',
      product
    })
  }, [count])
  return (
    <>
      <div className='act-product-item'>
        <ProductImage imgSrc={product.pic} width={80} />
        <div className='act-product-info'>
          <div className='act-product-name'>
            <h3>{product.name}</h3>
          </div>
          <div className='act-product-price'>
            <div className='price-info'>
              <span dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(product.actualPrice) }}></span>
              {product.actualPrice !== product.price && <del dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(product.price) }}></del>}
            </div>
            {/* <Icon name='tianjia' /> */}
            <Stepper cnt={count} onChange={handleChangeCnt} hideMinus={count === 0} disabled={cartMobx.info.eatType !== 'dinein' && !product.isCanTogo} />
          </div>
        </div>
      </div>
    </>
  )
}

export default observer(ActProductItem)
